var React = require('react');

function ArrowRightLarge (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},React.createElement("path",{"d":"m16.25 16.25 7.25-7.5-7.25-7.5M1.25 8.75H23.5"})));
}

ArrowRightLarge.defaultProps = {"width":"24.75","height":"17.5","data-name":"Layer 1","viewBox":"0 0 24.75 17.5"};

module.exports = ArrowRightLarge;

ArrowRightLarge.default = ArrowRightLarge;
